import {useCallback, useState} from 'react';

import {obtainAndSaveAuthCredentials} from 'src/openapi/admin/apis/SalesforceControllerApi';
import {useAppDispatch} from 'src/store/hooks';
import {getError} from 'src/utils/get-error';

import {LocalStorage} from '@pb/kit-util-client-storage';


import {getConnectionErrorMessage} from '../../utils/getDuplicatesErrorMessage';

type Props = {
    onSuccess: () => void,
    onFailure: (error: string) => void,
};

export const useSaveSalesforceAuth = ({onSuccess, onFailure}: Props) => {
    const apiDispatch = useAppDispatch();
    const [isLoading, setIsLoading] = useState(false);

    const action = useCallback(async (actionProps: {accountId: number, code: string, codeVerifier?: string | null}) => {
        setIsLoading(true);
        const {accountId, code, codeVerifier} = actionProps;
        const sandBox = LocalStorage.get(`salesforce-auth-sandbox-${accountId}`) as boolean | undefined;
        const saveAuthResponse = await apiDispatch(obtainAndSaveAuthCredentials({
            accountId,
            body: code,
            sandBox,
            codeVerifier: codeVerifier ?? undefined,
        }));
        if (saveAuthResponse.payload.success && saveAuthResponse.payload.data.type?.code === 'dup') {
            onFailure(getConnectionErrorMessage(saveAuthResponse.payload.data));
        } else if (saveAuthResponse.payload.success) {
            onSuccess();
        } else {
            onFailure(getError({error: saveAuthResponse.payload.data, separator: ' '}));
        }
        setIsLoading(false);
    }, [onSuccess, onFailure, apiDispatch]);

    return {isLoading, action};
};
